import React, { useEffect, useState } from "react";
import {
  TextInput,
  Row,
  Column,
  FormGroup,
  RadioButtonGroup,
  RadioButton,
} from "carbon-components-react";
import useGet from "../../hooks/useGet";
import useAuth from "../../hooks/useAuth";
import GenericCombo from "../Combos/GenericCombo";
import ProvinceCombo from "../Combos/ProvinceCombo";
import DistrictCombo from "../Combos/DistrictCombo";
import { toast } from "react-toastify";
import http from "../../http-common";

const PersonalDataForm = ({
  disabled,
  reset,
  register,
  control,
  errors,
  candidature,
  hasOwnBusiness,
  setHasOwnBusiness,
  disbaleBusinessCheck = true,
}) => {
  const { data: genders } = useGet("/lookup/genders");
  const { data: idDocTypes } = useGet("/lookup/identification-doc-types");
  const { data: academicLevels } = useGet("/lookup/academic-levels");
  const [districts, setDistricts] = useState([]);
  const [canWriteInPT, setCanWriteInPT] = useState(true);
  const [otherDocType, setOtherDocType] = useState(false);
  const [otherLanguage, setOtherLanguage] = useState(false);
  const [hasOtherAcademicLevel, setHasOtherAcademicLevel] = useState(false);

  const { isCompetitor } = useAuth();

  const getDistricts = async (provinceId) => {
    if (provinceId) {
      try {
        const response = await http.get(
          "/lookup/provinces/" + provinceId + "/districts"
        );
        setDistricts(response.data);
      } catch (error) {
        toast.error(error?.response?.data.message);
      }
    } else {
      setDistricts([]);
    }
  };

  const handleDocTypeChange = (e) => {
    if (e.target.value == 0) {
      setOtherDocType(true);
    } else {
      setOtherDocType(false);
      // reset({ otherIdentificationDocType: "" });
    }
  };

  const handleAcademicLevelChange = (e) => {
    if (e.target.value == 0) {
      setHasOtherAcademicLevel(true);
    } else {
      setHasOtherAcademicLevel(false);
      // reset({ otherAcademicLevel: "" });
    }
  };

  const handleLanguageChange = (value) => {
    if (value === "true") {
      setOtherLanguage(true);
    } else {
      setOtherLanguage(false);
      // reset({ anotherLanguage: "" });
    }
  };

  const handleWritingInPT = (value) => {
    if (value === "true") {
      setCanWriteInPT(true);
    } else {
      setCanWriteInPT(false);
      // reset({ anotherLanguage: "" });
    }
  };

  const handleOwnBusiness = (value) => {
    if (value === "true") {
      setHasOwnBusiness(true);
    } else {
      setHasOwnBusiness(false);
      toast.error(
        "Somente candidatos que possuem negócios podem se candidatar"
      );
    }
  };

  useEffect(() => {
    if (candidature) {
      getDistricts(candidature.provinceId);
      setCanWriteInPT(candidature.writesInPortuguese);
    }
  }, [candidature]);

  return (
    <FormGroup legendText="DADOS PESSOAIS" className="section-header">
      <fieldset className="bx--fieldset">
        <Row>
          <Column xml={12} sm={12} md={12} lg={12} className="required">
            <p>
              1. Este é o formulário de candidatura ao{" "}
              <strong>PROJECTO CONECTA NEGÓCIOS – Ligações de Consumo</strong>,
              que está a ser implementado pelo Ministério de Economia e
              Finanças, com apoio do Banco Mundial. Aceita responder a este
              formulário de forma voluntária e que a nossa equipa possa usar os
              dados recolhidos para fins relacionados com este projecto? Ao
              aceitar responder a este formulário não poderá deixar nenhuma
              questão em branco. Muito Obrigado (a)!
            </p>
            <RadioButtonGroup
              name="dataUseConsent"
              disabled={disabled}
              valueSelected={candidature?.dataUseConsent?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="consent-y"
                {...register("dataUseConsent")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="consent-n"
                {...register("dataUseConsent")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.dataUseConsent?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={12} md={12} lg={12} className="required">
            <TextInput
              labelText="1.1 Nome Completo"
              id="name"
              maxLength={255}
              disabled={disabled}
              {...register("name")}
            />
            <p className="field-error">{errors.name?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column sm={12} md={4} lg={4} className="required">
            <RadioButtonGroup
              name="ownsABusiness"
              disabled={disbaleBusinessCheck}
              legendText="1.2 Possui negócio próprio, mesmo que não esteja formalizado?"
              valueSelected={candidature?.ownsABusiness?.toString()}
              onChange={handleOwnBusiness}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="owns-y"
                {...register("ownsABusiness")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="owns-n"
                {...register("ownsABusiness")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.ownsABusiness?.message}</p>
          </Column>
          <Column sm={12} md={8} lg={8} className="required">
            <TextInput
              labelText="1.3 Indique a sua ocupação actual"
              id="currentOccupation"
              maxLength={255}
              disabled={disabled}
              {...register("currentOccupation")}
            />
            <p className="field-error">{errors.currentOccupation?.message}</p>
          </Column>
        </Row>
        {hasOwnBusiness && (
          <>
            <Row>
              <Column xml={12} sm={6} md={6} lg={6} className="required">
                <TextInput
                  placeholder="dd/mm/aaaa"
                  labelText="2. Data de Nascimento"
                  id="birthDate"
                  disabled={disabled}
                  {...register("birthDate")}
                />
                <p className="field-error">{errors.birthDate?.message}</p>
              </Column>
              <Column xml={12} sm={6} md={6} lg={6} className="required">
                <GenericCombo
                  id="gender"
                  name="gender"
                  label="3. Género"
                  disabled={disabled}
                  register={register}
                  items={genders}
                />
                <p className="field-error">{errors.gender?.message}</p>
              </Column>
            </Row>
            <Row>
              <Column xml={12} sm={6} md={4} lg={4} className="required">
                <GenericCombo
                  id="identificationDocTypeCode"
                  name="identificationDocTypeCode"
                  label="4. Documento de Identificação"
                  disabled={disabled}
                  register={register}
                  items={idDocTypes}
                  onChange={handleDocTypeChange}
                />
                <p className="field-error">
                  {errors.identificationDocTypeCode?.message}
                </p>
              </Column>
              <Column xml={12} sm={6} md={4} lg={4}>
                <TextInput
                  id="otherIdentificationDocType"
                  labelText="Outro (especifique)"
                  maxLength={64}
                  disabled={!otherDocType}
                  {...register("otherIdentificationDocType")}
                />
                <p className="field-error">
                  {errors.otherIdentificationDocType?.message}
                </p>
              </Column>
              <Column xml={12} sm={6} md={4} lg={4} className="required">
                <TextInput
                  id="identificationDocNumber"
                  labelText="Número do documento"
                  maxLength={13}
                  disabled={disabled}
                  {...register("identificationDocNumber")}
                />
                <p className="field-error">
                  {errors.identificationDocNumber?.message}
                </p>
              </Column>
            </Row>
            <Row>
              <Column sm={12} md={4} lg={4} className="required">
                <TextInput
                  id="phoneNumber"
                  labelText="5. Telemóvel (sem +258) "
                  maxLength={9}
                  disabled={disabled || isCompetitor}
                  {...register("phoneNumber")}
                />
                <p className="field-error">{errors.phoneNumber?.message}</p>
              </Column>
              <Column sm={12} md={4} lg={4}>
                <TextInput
                  id="whatsAppNumber"
                  labelText="6. WhatsApp (sem +258) "
                  maxLength={9}
                  disabled={disabled}
                  {...register("whatsAppNumber")}
                />
                <p className="field-error">{errors.whatsAppNumber?.message}</p>
              </Column>
              <Column sm={12} md={4} lg={4}>
                <TextInput
                  id="alternativePhoneNumber"
                  labelText="7. Contacto alternativo (sem +258)"
                  maxLength={9}
                  disabled={disabled}
                  {...register("alternativePhoneNumber")}
                />
                <p className="field-error">
                  {errors.alternativePhoneNumber?.message}
                </p>
              </Column>
            </Row>
            <Row>
              <Column xml={12} sm={6} md={4} lg={4}>
                <TextInput
                  id="email"
                  labelText="8. Email"
                  maxLength={128}
                  disabled={disabled}
                  {...register("email")}
                />
                <p className="field-error">{errors.email?.message}</p>
              </Column>
              <Column xml={12} sm={6} md={4} lg={4} className="required">
                <ProvinceCombo
                  id="provinceId"
                  name="provinceId"
                  label="9. Província"
                  disabled={disabled}
                  control={control}
                  setDistricts={setDistricts}
                />
                <p className="field-error">{errors.provinceId?.message}</p>
              </Column>

              <Column xml={12} sm={6} md={4} lg={4} className="required">
                <DistrictCombo
                  id="districtId"
                  name="districtId"
                  label="10. Cidade/Distrito"
                  disabled={disabled}
                  items={districts}
                  control={control}
                />
                <p className="field-error">{errors.districtId?.message}</p>
              </Column>
            </Row>
            <Row>
              <Column sm={12} md={12} lg={12} className="required">
                <TextInput
                  id="address"
                  labelText="11. Endereço (Localidade, Bairro, Rua, Avenida)"
                  maxLength={255}
                  disabled={disabled}
                  {...register("address")}
                />
                <p className="field-error">{errors.address?.message}</p>
              </Column>
            </Row>
            <Row>
              <Column sm={12} md={4} lg={4} className="required">
                <RadioButtonGroup
                  name="speaksAndUnderstandsPortuguese"
                  disabled={disabled}
                  legendText="12 Fala, percebe a língua portuguesa?"
                  valueSelected={candidature?.speaksAndUnderstandsPortuguese?.toString()}
                >
                  <RadioButton
                    labelText="Sim"
                    value="true"
                    id="speak-y"
                    {...register("speaksAndUnderstandsPortuguese")}
                  />
                  <RadioButton
                    labelText="Não"
                    value="false"
                    id="speak-n"
                    {...register("speaksAndUnderstandsPortuguese")}
                  />
                </RadioButtonGroup>
                <p className="field-error">
                  {errors.speaksAndUnderstandsPortuguese?.message}
                </p>
              </Column>
              <Column sm={12} md={4} lg={4} className="required">
                <RadioButtonGroup
                  name="writesInPortuguese"
                  disabled={disabled}
                  legendText="12.1 Escreve em língua portuguesa?"
                  valueSelected={candidature?.writesInPortuguese?.toString()}
                  onChange={handleWritingInPT}
                >
                  <RadioButton
                    labelText="Sim"
                    value="true"
                    id="write-y"
                    {...register("writesInPortuguese")}
                  />
                  <RadioButton
                    labelText="Não"
                    value="false"
                    id="write-n"
                    {...register("writesInPortuguese")}
                  />
                </RadioButtonGroup>
                <p className="field-error">
                  {errors.writesInPortuguese?.message}
                </p>
              </Column>
              {!canWriteInPT && (
                <Column sm={12} md={4} lg={4}>
                  <RadioButtonGroup
                    name="speaksAndWritesInAnotherLanguage"
                    disabled={disabled}
                    legendText="12.2 Se não, fala e escreve em outra língua?"
                    valueSelected={candidature?.speaksAndWritesInAnotherLanguage?.toString()}
                    onChange={handleLanguageChange}
                  >
                    <RadioButton
                      labelText="Sim"
                      value="true"
                      id="another-l-y"
                      {...register("speaksAndWritesInAnotherLanguage")}
                    />
                    <RadioButton
                      labelText="Não"
                      value="false"
                      id="another-l-n"
                      {...register("speaksAndWritesInAnotherLanguage")}
                    />
                  </RadioButtonGroup>
                  <p className="field-error">
                    {errors.speaksAndWritesInAnotherLanguage?.message}
                  </p>
                </Column>
              )}
            </Row>
            <Row>
              {!canWriteInPT && (
                <Column sm={12} md={4} lg={4}>
                  <TextInput
                    id="anotherLanguage"
                    labelText="12.3 Outra Língua"
                    maxLength={255}
                    disabled={!otherLanguage}
                    {...register("anotherLanguage")}
                  />
                  <p className="field-error">
                    {errors.anotherLanguage?.message}
                  </p>
                </Column>
              )}
              <Column sm={12} md={4} lg={4} className="required">
                <GenericCombo
                  id="academicLevelCode"
                  name="academicLevelCode"
                  label="13. Qual é o seu nível de escolaridadde mais alto concluído?  "
                  disabled={disabled}
                  register={register}
                  items={academicLevels}
                  onChange={handleAcademicLevelChange}
                />
                <p className="field-error">
                  {errors.academicLevelCode?.message}
                </p>
              </Column>
              <Column sm={12} md={4} lg={4}>
                <TextInput
                  id="otherAcademicLevel"
                  labelText="13.1 Outro nível académico"
                  maxLength={255}
                  disabled={!hasOtherAcademicLevel}
                  {...register("otherAcademicLevel")}
                />
                <p className="field-error">
                  {errors.otherAcademicLevel?.message}
                </p>
              </Column>
            </Row>
          </>
        )}
      </fieldset>
    </FormGroup>
  );
};

PersonalDataForm.defaultProps = {
  disabled: false,
};

export default PersonalDataForm;
